/* import __COLOCATED_TEMPLATE__ from './activation-status-gate.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
let ActivationStatusGate = (_dec = computed('args.featureSetKey', 'userSubscriptions.featureSetStatusResult.data'), _class = class ActivationStatusGate extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor, this);
  }
  get isActive() {
    return this.userSubscriptions.isFeatureSetActive(this.args.featureSetKey);
  }
  get isLoading() {
    return this.userSubscriptions.featureSetStatusResult?.isLoading;
  }
  get isError() {
    return this.userSubscriptions.featureSetStatusResult?.isError;
  }
  get showContent() {
    if (this.isLoading) {
      return false;
    }
    if (this.isError) {
      return this.args.fallbackActivationStatus;
    }
    return this.isActive;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isActive", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isActive"), _class.prototype), _class);
export { ActivationStatusGate as default };